import { TypedDocumentNode } from '@apollo/client';

import { SearchOperator } from '@sorare/core/src/__generated__/globalTypes';

export const OPERATORS: Record<string, SearchOperator> = {
  '=': SearchOperator.EQUAL,
  '>': SearchOperator.GREATER_THAN,
  '>=': SearchOperator.GREATER_THAN_OR_EQUAL,
  '<': SearchOperator.LESS_THAN,
  '<=': SearchOperator.LESS_THAN_OR_EQUAL,
  '!=': SearchOperator.NOT_EQUAL,
};

export type ExtractRightHandSide<T> = T extends `${string}-${infer U}`
  ? U
  : never;

export type extractQueryGeneric<Type> =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Type extends TypedDocumentNode<infer Q, infer V> ? Q : never;

export type extractVariableGeneric<Type> =
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Type extends TypedDocumentNode<infer Q, infer V> ? V : never;
